import { Card, FormLayout, Layout, TextField } from "@shopify/polaris";
import { useFormikContext } from "formik";

export function InfoSection({ isDetail }) {
  const { values, setFieldValue, handleBlur } = useFormikContext();
  return (
    <Layout.AnnotatedSection
      title="Temel Bilgiler"
      description="Muhasebe kaydı bilgilerini eksiksiz ve doğru girdiğinizden emin olun."
    >
      <Card sectioned>
        <FormLayout>
          <TextField
            label="Başlık"
            name="title"
            requiredIndicator
            value={values.title}
            onChange={(value) => setFieldValue("title", value)}
            onBlur={handleBlur}
          />
          <TextField
            label="Açıklama"
            multiline={true}
            name="description"
            value={values.description}
            onChange={(value) => setFieldValue("description", value)}
            onBlur={handleBlur}
          />
        </FormLayout>
      </Card>
    </Layout.AnnotatedSection>
  );
}
